
import { PropType, defineComponent } from 'vue'

export default defineComponent({
    props: {
        startColor: {
            type: String as PropType<string>,
            default: () => '#E2C785'
        },
        endColor: {
            type: String as PropType<string>,
            default: () => '#A38543'
        }
    }
})
